// ADD TO THIS AS NEEDED

export const UID = {
  bArimoto: '1921', // brent
  bGautam: '3369', // bishal
  bMattson1: '1453', // ben m
  bMattson2: '3372', // ben m
  cClemens1: '4089', // cami
  cClemens2: '4108', // cami
  dKim: '2346', // diana
  eHanifan: '3996', // emily
  eLi: '3375', // elson
  eLy1: '2760', // eugenie
  eLy2: '3417', // eugenie
  eThollard: '4232', // emmanuel
  gLi: '2776', // gordon
  hWelsch: '5309', // hunter
  jPak1: '2685', // jin
  jPak2: '3439', // jin
  jZamora: '2775', // jon
  kBahl: '3429', // kaav
  kHufford1: '747', // kenny
  kHufford2: '3377', // kenny
  mMartinez: '167', // monica
  nCuenca: '2170', // nathan
  nDavison1: '2265', // nathan
  nDavison2: '3438', // nathan
  nDhawale: '4909', // nilesh
  rSingh: '4192', // ripan
  rZamudio: '4728', // rogelio
  sCarr: '3155', // samantha
  sGaillard1: '2953', // segolene
  sGaillard2: '3416', // segolene
  sKuh: '3498', // sophia
  sMcEvilly1: '2870', // sarah
  sMcEvilly2: '3412', // sarah
  tDang: '3886', // tiffany
  tGreen: '3736', // trey
  tTsukada: '4945', // tetsuya
  vChao: '2738', // vern
};

export const UX_TEAM_IDS = [UID.mMartinez];

export const PUB_OPS_TEAM_IDS = [
  UID.bMattson1,
  UID.bMattson2,
  UID.cClemens1,
  UID.cClemens2,
  UID.eHanifan,
  UID.eLy1,
  UID.eLy2,
  UID.eThollard,
  UID.hWelsch,
  UID.jPak1,
  UID.jPak2,
  UID.nDavison1,
  UID.nDavison2,
  UID.rZamudio,
  UID.sGaillard1,
  UID.sGaillard2,
  UID.sKuh,
  UID.sMcEvilly1,
  UID.sMcEvilly2,
  UID.tGreen,
  UID.tTsukada,
];
